import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useTeachingDeliveryDetails = (unitWorkloadId: number, campusId: number) => {
  return trpc.getTeachingDeliveryDetails.useQuery(
    { unitWorkloadId, campusId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId,
    },
  );
};
